export const DocumentStatus = {
  InProgress: 1,
  Completed: 2,
  AdviserReview: 3,
  ReviewEnded: 4,
}
